// src/components/forms/fields/SelectManyField.tsx
// Utworzony w Krok 3

import React from 'react';
import { 
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Box
} from '@mui/material';
import { FormSection } from '../../../types/forms';

interface SelectManyFieldProps {
  section: FormSection;
  value: string[] | undefined;
  onChange: (value: string[]) => void;
  error?: string;
}

export const SelectManyField: React.FC<SelectManyFieldProps> = ({ 
  section, 
  value = [], 
  onChange, 
  error 
}) => {
  const options = section.config?.options || [];

  const handleChange = (optionValue: string | number) => {
    const stringValue = String(optionValue);
    const currentValues = Array.isArray(value) ? value : [];
    
    const isSelected = currentValues.includes(stringValue);
    
    if (isSelected) {
      // Remove from selection
      const newValues = currentValues.filter(v => v !== stringValue);
      onChange(newValues);
    } else {
      // Add to selection
      onChange([...currentValues, stringValue]);
    }
  };

  const isChecked = (optionValue: string | number): boolean => {
    if (!Array.isArray(value)) return false;
    return value.includes(String(optionValue));
  };

  return (
    <Box sx={{ mb: 3 }}>
      <FormControl 
        error={!!error} 
        required={!!section.validation?.required}
        component="fieldset"
      >
        <FormLabel component="legend" sx={{ mb: 1 }}>
          {section.label}
        </FormLabel>
        
        <FormGroup>
          {options.map((option) => (
            <FormControlLabel
              key={String(option.value)}
              control={
                <Checkbox
                  checked={isChecked(option.value)}
                  onChange={() => handleChange(option.value)}
                  color="primary"
                />
              }
              label={option.label}
              sx={{ mb: 0.5 }}
            />
          ))}
        </FormGroup>
        
        {(error || section.description) && (
          <FormHelperText sx={{ mt: 1 }}>
            {error || section.description}
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};